import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

const CARDS = [
  { pillKey: "whyUs.confidence.card1.pill", titleKey: "whyUs.confidence.card1.title", textKey: "whyUs.confidence.card1.text" },
  { pillKey: "whyUs.confidence.card2.pill", titleKey: "whyUs.confidence.card2.title", textKey: "whyUs.confidence.card2.text" },
  { pillKey: "whyUs.confidence.card3.pill", titleKey: "whyUs.confidence.card3.title", textKey: "whyUs.confidence.card3.text" },
  { pillKey: "whyUs.confidence.card4.pill", titleKey: "whyUs.confidence.card4.title", textKey: "whyUs.confidence.card4.text" },
];

const BTN_GRADIENT_DARK =
  "linear-gradient(-84deg, rgba(14,28,54,0.8) 6%, rgba(3,65,180,0.8) 66%)";

function Confidence() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[38px] items-start">
          {/* Слева: заголовок + текст + кнопка */}
          <Fade triggerOnce direction="left" duration={700} className="lg:w-[383px] shrink-0">
          <div className="flex flex-col items-start">
            <div className="flex flex-col gap-[4px]">
              <h2 className="font-42-28">{t("whyUs.confidence.title1")}</h2>
              <h3 className="font-32-22">{t("whyUs.confidence.title2")}</h3>
            </div>
            <p className="mt-[15px] font-16-14 max-w-[344px]">
              {t("whyUs.confidence.subtitle")}
            </p>
            <a
              href={link}
              className="mt-[25px] lg:mt-[35px] inline-flex items-center justify-center px-[32px] lg:px-[42px] py-[14px] lg:py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[14px] lg:text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
              style={{ backgroundImage: BTN_GRADIENT_DARK }}
            >
              {t("whyUs.confidence.cta")}
            </a>
          </div>
          </Fade>

          {/* Справа: 2x2 тёмные карточки */}
          <div className="flex-1 w-full grid grid-cols-1 sm:grid-cols-2 gap-[16px] lg:gap-[25px]">
            <Fade cascade triggerOnce direction="up" damping={0.08}>
              {CARDS.map((card) => (
                <div
                  key={card.titleKey}
                  className="bg-[#1c385f] rounded-[20px] p-[25px] lg:p-[35px] flex flex-col gap-[25px]"
                >
                  <div className="bg-white inline-flex items-center self-start px-[12px] py-[8px] rounded-full">
                    <span className="font-['Inter'] font-bold text-[12px] text-[#1c385f]">
                      {t(card.pillKey)}
                    </span>
                  </div>
                  <div className="flex flex-col gap-[15px]">
                    <p className="font-['Inter'] font-bold text-[18px] lg:text-[20px] leading-[1.2] text-white">
                      {t(card.titleKey)}
                    </p>
                    <p className="font-['Inter'] font-normal text-[14px] lg:text-[16px] leading-[1.5] text-white">
                      {t(card.textKey)}
                    </p>
                  </div>
                </div>
              ))}
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Confidence;
